import { Component, OnInit } from '@angular/core';

import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BodyComponent } from './body/body.component';
import { HeaderComponent } from './header/header.component';
@Component({
  selector: 'app-layout',
  imports: [
    MatDatepickerModule,
    MatNativeDateModule,
    NgxSpinnerModule,
    BodyComponent,
    HeaderComponent
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
